import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/playbooks",
)({
  staticData: {
    breadcrumb: [
      { label: "Quoting - Playbooks", href: "/settings/quoting/playbooks" },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "quote_ruleset:read",
      "/settings/workspace/general",
    ),
})
